import { 
  signInWithPopup, 
  signOut, 
  onAuthStateChanged, 
  User 
} from "firebase/auth";
import { auth, googleProvider } from "../utils/firebase";

// This email is the only one allowed to access the admin panel
const ADMIN_EMAIL = "rogerjs93@gmail.com";

// Sign in with Google
export const signInWithGoogle = async (): Promise<{user: User | null, isAdmin: boolean, error?: string}> => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;
    
    // Check if the user's email matches the admin email
    const isAdmin = user.email === ADMIN_EMAIL;
    
    if (!isAdmin) {
      await signOut(auth);
      return { 
        user: null, 
        isAdmin: false, 
        error: "Unauthorized access. Only specific administrators can log in." 
      };
    }
    
    return { user, isAdmin };
  } catch (error: any) {
    console.error("Error signing in with Google:", error);
    return { 
      user: null, 
      isAdmin: false, 
      error: error.message || "Failed to sign in with Google" 
    };
  }
};

// Sign out
export const signOutUser = async (): Promise<void> => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("Error signing out:", error);
  }
};

// Set up auth state observer
export const observeAuthState = (callback: (user: User | null, isAdmin: boolean) => void) => {
  return onAuthStateChanged(auth, (user) => {
    const isAdmin = user?.email === ADMIN_EMAIL;
    callback(user, isAdmin);
  });
};